import { withSvgIcon } from './withSvgIcon';

export const DesktopIcon = withSvgIcon(
  <>
    <path d="M3.5 6C3.5 4.89543 4.39543 4 5.5 4H15C16.1046 4 17 4.89543 17 6V12C17 13.1046 16.1046 14 15 14H5.5C4.39543 14 3.5 13.1046 3.5 12V6Z" stroke="currentColor" strokeWidth="1.5" />
    <path d="M6.5 17.5H13.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M10 14V17" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 20 20' },
);
